<mat-button-toggle-group
  class="pkt-toggle-group"
  [class.pkt-toggle-group--sm]="size === 'sm'"
  [class.pkt-toggle-group--lg]="size === 'lg'"
  [value]="value"
  [disabled]="disabled"
  (change)="onGroupChange($event.value)">
  <mat-button-toggle
    *ngFor="let opt of options"
    [value]="opt.value"
    [disabled]="opt.disabled">
    <span *ngIf="opt.icon" class="material-symbols-outlined pkt-toggle-icon">{{ opt.icon }}</span>
    <span *ngIf="opt.label" class="pkt-toggle-label">{{ opt.label }}</span>
  </mat-button-toggle>
</mat-button-toggle-group>
